module.exports = __webpack_public_path__ + "assets/img/logo.dbc12e75.png";